import React from "react";

import "../../../../styles/css/App.css";
import { MapContainer, TileLayer, Polyline, Tooltip } from "react-leaflet";

import EmergencyMarker from "./marker"
import { states } from '../../../../plas/services/emergency/models';

function EmergencyMap({ victims, center }) {
  
  const warningPathOptions = {color: '#CEBF07'}
  const dangerPathOptions = {color: '#F99B38'}
  const alertPathOptions = {color: '#F94638'}

  const [map, setMap] = React.useState(null);

  React.useEffect(() => {
    if (map)
      map.setView([center.lat, center.lon], 17);
  }, [center]);

  const getPathOptions = (victim) => {
    if (victim.state === states.victimStates.ALERT)
      return alertPathOptions;
    if (victim.state === states.victimStates.DANGER)
      return dangerPathOptions;
    else 
      return warningPathOptions;
  } 

  return (
    <div>
      <MapContainer 
        style={{
          height: "calc(100vh - 180px)",
          width: "100%",
          overflow: "hidden",
          zIndex: '399'
        }}
        center={center}
        zoom={14}
        scrollWheelZoom={true}
        whenCreated={setMap}>
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>

        { victims.map((victim) =>
          (
            <fragment key={victim.userId}>
              { victim.mobility && (
                <>
                  <EmergencyMarker
                    mobility={victim.mobility}
                    alert={victim.alert}
                    isVictim={true}
                    profile={victim.profile}
                    key={victim.userId+"-victim"}/>

                  { victim.restrictions.map((perimetral) => 
                    <fragment key={perimetral.id}>
                      <EmergencyMarker
                        mobility={perimetral.mobility}
                        alert={victim.alert}
                        isVictim={false}
                        profile={perimetral.profile}
                        key={victim.userId+"-victimizer"}
                      />
                      { victim.mobility.location && perimetral.mobility && perimetral.mobility.location && (
                        <Polyline 
                          positions={[
                            [victim.mobility.location.latitude,victim.mobility.location.longitude],
                            [perimetral.mobility.location.latitude,perimetral.mobility.location.longitude]
                          ]}
                          pathOptions={getPathOptions(victim)}>

                          <Tooltip>
                            <b style={{fontSize: 14}}>{perimetral.distanceAsText()}</b>
                          </Tooltip>
                        </Polyline>
                      )}
                    </fragment>
                  )}
                </>
              )}
            </fragment>
          )
        )}
      </MapContainer> 
    </div>
  );

}

export default EmergencyMap;